export interface LoginCredentials {
  email: string;
  password: string;
}

export interface UserData {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: string;
  instituteId?: string;
}

export interface LoginResponse {
  accessToken: string;
  user: UserData;
}

export class AuthError extends Error {
  constructor(
    message: string,
    public isAccessDenied: boolean = false,
    public isNetworkError: boolean = false,
  ) {
    super(message);
    this.name = 'AuthError';
  }
}
